export const environment = {
  /**
   * マップの切り替え.
   *
   * - none : マップ使用しない
   * - osm : OpenStreetMap
   * - google : Google Map
   *    `index.html` に `<script src="https://maps.googleapis.com/maps/api/js?key=${GoogleMapApikey}" async defer></script>` を指定してください。
   */
  map: 'google',
  servicerApiUrl: 'https://nissan-mslab-mw.com/vehicle',
  servicerApiUrls: [
    'https://nissan-mslab-mw.com/vehicle',
    'http://localhost:8081'
  ],
  /**
   * タイトル.
   *
   * - 浪江/NATC(浪江同等) : Namie Mobility Service
   * - シャドーFMS/横浜 : Nissan Mobility Service
   */
  title: 'Mobility Service',
  /**
   * [システム]ダッシュボードAPIを取得する間隔（単位：ms）.
   * FMS/CMS の一覧を表示する間隔に影響する.
   *
   * - 浪江/NATC(浪江同等) : 10000
   * - シャドーFMS/横浜 : 1000
   */
  systemDashboardInterval: 10000,
  /**
   * シミュレート結果を確認する間隔（単位：ms）.
   */
  simulateResultInterval: 10000,
  /**
   * [システム] [休憩計画]ダッシュボードAPIを取得する間隔（単位：ms）.
   */
  systemRestPlanDashboardInterval: 10000,
  /**
   * [休憩計画] 需要の評価の色を変えるための値.
   */
  restPlanDemandCount: 10,
  /**
   * エリアインデックス.
   *
   * - 横浜 : 1
   */
  areaIndex: 0,
  /** エリアリスト. */
  red5ProliveStream : {
    red5ProUsername: '',
    red5ProPassword: '',
    red5ProHost: '',
    red5ProPort: 443,
    red5ProApp: 'live',
    red5ProMediaElementId: ''
  },
  peerServerInfo : {
    peerHost: '',
    peerPort: 9001,
    peerpath: '/'
  },
  areas: [
    {
      name: '横浜',
      areaId: 3,
      hubAreaId: null,
      spokeAreaId: 3,
      lat: 35.450939000,
      lon: 139.638361000,
      zoom: 15,
      userPattern: '^(U|N)(0[0-9][0-9]|100)$',
      fmsVehicles:[
        {
          category: {
            title: 'サービス車両',
            activeVehicleEnabled: true
          },
          vehicles: [
          ]
        }
      ],
      basePolylines: []
    }
  ]
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts